import { render, staticRenderFns } from "./HighchartsFormattingWrapper.vue?vue&type=template&id=15691782&"
import script from "./HighchartsFormattingWrapper.vue?vue&type=script&lang=js&"
export * from "./HighchartsFormattingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports